module.exports = __webpack_public_path__ + "static/media/ls.99ede3ec.jpeg";